import { render, staticRenderFns } from "./OrderTableExpand.vue?vue&type=template&id=6cbe4ca4&scoped=true&"
import script from "./OrderTableExpand.vue?vue&type=script&lang=js&"
export * from "./OrderTableExpand.vue?vue&type=script&lang=js&"
import style0 from "./OrderTableExpand.vue?vue&type=style&index=0&id=6cbe4ca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbe4ca4",
  null
  
)

export default component.exports